import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../config/siteConfig';

function Footer() {
  return (
  <footer className="text-white py-12 bg-brand-navy">
      <div className="ffp-container-reading">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 mb-8 text-center sm:text-left">

          {/* Logo & Company Info */}
          <div className="md:col-span-1 flex flex-col items-center sm:items-start">
            <img
              src="/ffp-logo-final.svg"
              alt="Flood & Fire Pros"
              className="h-12 w-auto mb-4"
            />
            <p className="font-open-sans text-sm text-gray-300 mb-4">
              Connecting property owners with verified restoration professionals across the Inland Empire.
            </p>
            <div className="flex space-x-4 justify-center sm:justify-start">
              {/* Social links - Update URLs when accounts are created */}
              <a
                href="https://www.facebook.com/FloodAndFirePros"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white transition-colors"
                aria-label="Follow us on Facebook"
              >
                <span className="sr-only">Facebook</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/flood-and-fire-pros"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white transition-colors"
                aria-label="Connect with us on LinkedIn"
              >
                <span className="sr-only">LinkedIn</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* For Homeowners */}
          <div>
            <h3 className="font-montserrat font-semibold text-lg mb-4">For Homeowners</h3>
            <ul className="space-y-2 font-open-sans text-sm">
              <li><Link to="/request-service" className="text-orange-400 hover:text-orange-300 transition-colors font-semibold">Get Help Now</Link></li>
              <li><Link to="/how-it-works" className="text-gray-300 hover:text-white transition-colors">How It Works</Link></li>
              <li><Link to="/find-contractors" className="text-gray-300 hover:text-white transition-colors">Find Contractors</Link></li>
              <li><Link to="/signup-homeowner" className="text-gray-300 hover:text-white transition-colors">Create Account</Link></li>
              <li><Link to="/resources" className="text-gray-300 hover:text-white transition-colors">Resources</Link></li>
            </ul>
          </div>

          {/* For Contractors */}
          <div>
            <h3 className="font-montserrat font-semibold text-lg mb-4">For Contractors</h3>
            <ul className="space-y-2 font-open-sans text-sm">
              <li><Link to="/restoration-professionals" className="text-gray-300 hover:text-white transition-colors">Why List With Us</Link></li>
              <li><Link to="/signup" className="text-orange-400 hover:text-orange-300 transition-colors font-semibold">Join Our Network</Link></li>
              <li><Link to="/dashboard" className="text-gray-300 hover:text-white transition-colors">Contractor Portal</Link></li>
            </ul>
          </div>

          {/* Company & Contact */}
          <div>
            <h3 className="font-montserrat font-semibold text-lg mb-4">Company</h3>
            <ul className="space-y-2 font-open-sans text-sm">
              <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-white transition-colors">Blog</Link></li>
              <li><Link to="/privacy" className="text-gray-300 hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-gray-300 hover:text-white transition-colors">Terms of Service</Link></li>
              <li><Link to="/sms-disclosure" className="text-gray-300 hover:text-white transition-colors">SMS Terms</Link></li>
            </ul>

            {/* Contact Info */}
            <div className="mt-6">
              <p className="font-open-sans text-sm text-gray-300">
                ✉️ <a href="mailto:support@flood-and-fire-pros.direct" className="transition-colors" style={{ ':hover': { color: siteConfig.colors.primary } }}>support@flood-and-fire-pros.direct</a>
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-600 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="font-open-sans text-sm text-gray-300 mb-4 md:mb-0">
© 2025 Flood & Fire Pros. All rights reserved.
          </p>
          <div className="flex space-x-6 font-open-sans text-sm">
            <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors">Privacy</Link>
            <Link to="/terms" className="text-gray-300 hover:text-white transition-colors">Terms</Link>
            <Link to="/sms-disclosure" className="text-gray-300 hover:text-white transition-colors">SMS Terms</Link>
            <Link to="/sitemap" className="text-gray-300 hover:text-white transition-colors">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
